import { programs } from "@/mocks/home";

export default function Programs() {
  return (
    <section id="program" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-block text-primary-600 text-sm font-semibold uppercase tracking-wider mb-3">
            Program Kami
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            Inisiatif Kebajikan Yang Kami Jalankan
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            Setiap sumbangan anda disalurkan terus kepada program-program
            kebajikan yang memberi impak sebenar kepada komuniti.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program) => {
            const progress = Math.min(
              Math.round((program.raised / program.goal) * 100),
              100
            );
            return (
              <div
                key={program.id}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200 flex flex-col"
              >
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold">
                    {program.category}
                  </span>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                      <i className={`${program.icon} text-base`}></i>
                    </span>
                    <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 leading-snug">
                      {program.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    {program.description}
                  </p>

                  <div className="mt-5">
                    <div className="flex items-center justify-between text-xs text-foreground-500 mb-2">
                      <span>
                        Terkumpul:{" "}
                        <span className="font-semibold text-primary-600">
                          RM {program.raised.toLocaleString("ms-MY")}
                        </span>
                      </span>
                      <span>Matlamat: RM {program.goal.toLocaleString("ms-MY")}</span>
                    </div>
                    <div className="w-full h-2 rounded-full bg-background-200">
                      <div
                        className="h-2 rounded-full bg-primary-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>

                  <a
                    href="#sumbangan"
                    className="mt-5 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-secondary-200 transition-colors"
                  >
                    Sumbang untuk program ini
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}